export enum DateRangeOptions {
  AnyTime,
  ThisMonth,
  PastMonth,
  ThisYear,
  PastYear,
}
